import {
  AIToolsClothingModelGeneratorCategoryProps,
  AIToolsClothingModelGeneratorModelClassProps,
  AIToolsClothingModelGeneratorModelTypeProps,
} from '../types/ai-tools';
import { STATIC_FILE_URL } from './web-constants';

export const AI_GENERATED_PIC_KEY = 'AI_GENERATED_PIC_KEY';
export const AI_TOOLS_TDK = 'ai-tools-tdk';
export const AI_T_SHIRT_TEMPLATE = 'ai-t-shirt-template';
export const AI_TOOLS_LOADING =
  'https://static.pietrastudio.com/public/file_uploads/d71d8ccb7264fb1ca4a4ec9a871849d1.gif';
export const AI_TOOLS_PAGE_NUM = 12;
export const AI_TOOLS_ITEMS: any[] = [];

export const CONTENT_STUDIO_ITEM = {
  imageSrc: 'https://static.pietrastudio.com/public/file_uploads/2293cababa32190055ec1eeaecdd308e.png',
  imageAlt: 'Pietra Content Studio',
  imageWidth: 992,
  imageHeight: 640,
  category: 'MARKETING',
  title: 'Pietra Content Studio',
  description: 'Elevate your product photos into eye-catching marketing visuals and videos, ready for any campaign.',
  href: '/platform/content-studio',
  icon: 'https://static.pietrastudio.com/public/file_uploads/f3a716f0cfe6e3db86c250c4b981298a.svg',
  linkStr: 'Try for free',
};

export const SOCIAL_ANALYSIS_ITEM = {
  imageSrc: 'https://static.pietrastudio.com/public/file_uploads/5ca3a2fa75fb4b6752c11c98a4e4fe49.png',
  imageAlt: 'Pietra Pulse',
  imageWidth: 992,
  imageHeight: 640,
  category: 'MARKETING',
  title: 'Pietra Pulse',
  description:
    'Stay ahead with your AI agent: track customer feedback, monitor competitors, uncover trends, and discover the perfect influencers.',
  href: '/platform/social-analysis',
  icon: 'https://static.pietrastudio.com/public/file_uploads/f3a716f0cfe6e3db86c250c4b981298a.svg',
  linkStr: 'Try for free',
};

export const CONTENT_STUDIO_ITEM_WITH_BUSINESS = {
  imageSrc: 'https://static.pietrastudio.com/public/file_uploads/2293cababa32190055ec1eeaecdd308e.png',
  imageAlt: 'Pietra Content Studio',
  imageWidth: 992,
  imageHeight: 640,
  category: 'MARKETING',
  title: 'Pietra Content Studio',
  description: 'Elevate your product photos into eye-catching marketing visuals and videos, ready for any campaign.',
  href: '/platform/content-studio',
  icon: 'https://static.pietrastudio.com/public/file_uploads/f3a716f0cfe6e3db86c250c4b981298a.svg',
  linkStr: 'Create e-commerce marketing assets',
};

export const SOCIAL_ANALYSIS_ITEM_WITH_BUSINESS = {
  imageSrc: 'https://static.pietrastudio.com/public/file_uploads/5ca3a2fa75fb4b6752c11c98a4e4fe49.png',
  imageAlt: 'Pietra Pulse',
  imageWidth: 992,
  imageHeight: 640,
  category: 'MARKETING',
  title: 'Pietra Pulse',
  description:
    'Stay ahead with your AI agent: track customer feedback, monitor competitors, uncover trends, and discover the perfect influencers.',
  href: '/platform/social-analysis',
  icon: 'https://static.pietrastudio.com/public/file_uploads/f3a716f0cfe6e3db86c250c4b981298a.svg',
  linkStr: 'Real-time social insights for your brand',
};

export const AI_TOOLS_ITEMS_WITH_BUSINESS = [
  { ...CONTENT_STUDIO_ITEM_WITH_BUSINESS },
  { ...SOCIAL_ANALYSIS_ITEM_WITH_BUSINESS },
  {
    imageSrc: 'https://static.pietrastudio.com/public/file_uploads/43b2dfbc7f8368dd2fc1d0dacb69d640.png',
    imageAlt: 'Pietra design studio',
    imageWidth: 992,
    imageHeight: 640,
    category: 'MARKETING',
    title: 'Product Design Studio',
    description:
      'Design custom products and packaging with AI. Choose from over 1,300 suppliers that can help turn your ideas into products.',
    href: '/platform/design-studio',
    icon: 'https://static.pietrastudio.com/public/file_uploads/f3a716f0cfe6e3db86c250c4b981298a.svg',
    linkStr: 'Start designing with AI',
  },
];
export const AI_TOOLS_LINKS = [...AI_TOOLS_ITEMS, ...AI_TOOLS_ITEMS_WITH_BUSINESS];

export const AI_T_SHIRT_GENERATOR_STYLE_LIST = {
  Photo:
    'Style: photo-realistic image with natural, soft lighting and a shallow depth of field.  vibrant natural color , detailed textures, and an eye-level perspective. Capture the subject in a lifelike pose within a realistic setting.',
  '3D Render':
    'Style: a highly detailed, 3D rendering style with realistic textures, lighting and shading. hyperrealism',
  'Line Art': 'Style: line art drawing with simplicity and clarity in composition',
  Illustration: 'Style: Illustration Art',
};
export const AI_T_SHIRT_GENERATOR_TEMPLATE =
  'https://static.pietrastudio.com/public/file_uploads/a644eccb9044b2b0e30069320d66b144.jpg';
export const AI_T_SHIRT_GENERATOR_TEMPLATE_NEW =
  'https://static.pietrastudio.com/public/file_uploads/e477dbc027fa093802d9bb218f3a896d.png';
export const PIETRA_MARK_ICON =
  'https://static.pietrastudio.com/public/file_uploads/f9983f34a7324573a468966c36a50d60.png';
export const AI_T_SHIRT_GENERATOR_PRODUCT_ID_STAGING = 767;
export const AI_T_SHIRT_GENERATOR_PRODUCT_ID_PRODUCTION = 766;

export const AI_COLOR_CHANGE_GENERATOR_DEFAULT_COLORS = [
  '#55A861',
  '#4C91C4',
  '#E1D3C7',
  '#BEBEBE',
  '#DC333C',
  '#EE7A9E',
];

export const AI_TOOLS_RECOMMEND_IDS = {
  '': '322150,322148,322501,322547,322554',
  'ninja turtle': '',
  venom: '',
  superhero: '',
  princess: '',
};

export const AI_TOOLS_BREADCRUMB_NAVIGATION = ['Home', 'Pietra AI Labs'];

export const AI_TOOLS_CLOTHING_MODEL_GENERATOR_EXAMPLE = {
  [AIToolsClothingModelGeneratorCategoryProps.UPPER_BODY]: {
    [AIToolsClothingModelGeneratorModelTypeProps.DC]: {
      [AIToolsClothingModelGeneratorModelClassProps.CLOTH]: [
        'https://static.pietrastudio.com/public/file_uploads/38fa034c6e016ac7a3f4e9d06f31a86e.jpg',
        'https://static.pietrastudio.com/public/file_uploads/d43e2a194d5518c175dffa5954311322.jpg',
        'https://static.pietrastudio.com/public/file_uploads/93e03c81db9d35b617fc4a0b9c6696d3.jpg',
        'https://static.pietrastudio.com/public/file_uploads/60bfee0bc6254c44927ccc207de0e474.jpg',
        'https://static.pietrastudio.com/public/file_uploads/c88d197978e3aca775f5da0f59eb7d1f.jpg',
        'https://static.pietrastudio.com/public/file_uploads/a72fbf72a5ef06fed223a7ca35c40480.jpg',
        'https://static.pietrastudio.com/public/file_uploads/4dd8bea9e4c052d9fd72ab394617cad7.jpg',
      ],
      [AIToolsClothingModelGeneratorModelClassProps.MODEL]: [
        'https://static.pietrastudio.com/public/file_uploads/bf18f1247bd79fe4693a292cbb797968.jpg',
        'https://static.pietrastudio.com/public/file_uploads/5e31f7050ebae2e40969cecc3d4dabb1.jpg',
        'https://static.pietrastudio.com/public/file_uploads/7e8ca24c8a78c36cdd6e16fa00f6bd74.jpg',
        'https://static.pietrastudio.com/public/file_uploads/8334b34047d6e001f1b19aa176378ec2.png',
        'https://static.pietrastudio.com/public/file_uploads/32290dab4ccd247e69523aefadc47aca.jpg',
        'https://static.pietrastudio.com/public/file_uploads/20f258b98a3a0a107f7980764d271c98.jpg',
        'https://static.pietrastudio.com/public/file_uploads/dd8d8839f5193658e783ac8d10e32e48.jpg',
      ],
    },
    [AIToolsClothingModelGeneratorModelTypeProps.HD]: {
      [AIToolsClothingModelGeneratorModelClassProps.CLOTH]: [
        'https://static.pietrastudio.com/public/file_uploads/0fd3637647467a1230da02037bcfbffd.jpg',
        'https://static.pietrastudio.com/public/file_uploads/17ea2970f03421a4a3784da64b8f739b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/3e96909a048cd2cf2830713748299ebb.jpg',
        'https://static.pietrastudio.com/public/file_uploads/bfe91c3b6b3e098eb717547b16681d72.jpg',
        'https://static.pietrastudio.com/public/file_uploads/fab5cd247f29118be4a267def42014ed.jpg',
        'https://static.pietrastudio.com/public/file_uploads/03b724a969cd390d4f898dab633e4769.jpg',
        'https://static.pietrastudio.com/public/file_uploads/96c0ac6a2d913ee57d81200d163dd5e9.jpg',
        'https://static.pietrastudio.com/public/file_uploads/98da66378be4891893f9414f9bb493cf.jpg',
        'https://static.pietrastudio.com/public/file_uploads/24b2253cf4b940a249e9114598fb775c.jpg',
        'https://static.pietrastudio.com/public/file_uploads/0872122296aef0123a61d86f80675a99.jpg',
        'https://static.pietrastudio.com/public/file_uploads/c748879c2d9d5ccd15eca0b54673fe86.jpg',
        'https://static.pietrastudio.com/public/file_uploads/361ed4058b642a063a37e10a1a3786f5.jpg',
        'https://static.pietrastudio.com/public/file_uploads/7b0a725541abda2dc2d42f46f637705e.jpg',
        'https://static.pietrastudio.com/public/file_uploads/354858475ef030e253b889922ab35162.jpg',
        'https://static.pietrastudio.com/public/file_uploads/38c4c978b6cc1bee777d98b9059b0d8b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/44a27588363ddef91023cc484cb1fd0d.jpg',
      ],
      [AIToolsClothingModelGeneratorModelClassProps.MODEL]: [
        'https://static.pietrastudio.com/public/file_uploads/51c301fca96601231be389ed788a213a.png',
        'https://static.pietrastudio.com/public/file_uploads/b422b02bef613a3425c580856384fb17.png',
        'https://static.pietrastudio.com/public/file_uploads/5fc3a7e06f62345d9a3b307d6c386aa9.png',
        'https://static.pietrastudio.com/public/file_uploads/ed44f76538480f0a4359e09f5ed7ac4c.png',
        'https://static.pietrastudio.com/public/file_uploads/c369bfbdb79c1ea2f05bb468cf93007f.png',
        'https://static.pietrastudio.com/public/file_uploads/08fdaf4fe10053469972cd198c4828e8.png',
        'https://static.pietrastudio.com/public/file_uploads/b9ca4c8f5e5ead6b963191d4de70d963.png',
        'https://static.pietrastudio.com/public/file_uploads/4d2c7c8d7bd63c32eb193a54ec9ad822.jpg',
        'https://static.pietrastudio.com/public/file_uploads/bec849d8fb201dfd4cead87a7e9b09d9.jpg',
        'https://static.pietrastudio.com/public/file_uploads/a32176375c2fe6e4d581f842dfdcb664.jpg',
        'https://static.pietrastudio.com/public/file_uploads/87b0354af6cd8db54d6e04ef53f72964.jpg',
        'https://static.pietrastudio.com/public/file_uploads/2b7e4755a11048927aa06f5a84278d0b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/8ba108c981608f8436b779add872415f.jpg',
        'https://static.pietrastudio.com/public/file_uploads/d76c76edce31148cac998eddd4ee3f71.jpg',
      ],
    },
  },
  [AIToolsClothingModelGeneratorCategoryProps.LOWER_BODY]: {
    [AIToolsClothingModelGeneratorModelTypeProps.DC]: {
      [AIToolsClothingModelGeneratorModelClassProps.CLOTH]: [
        'https://static.pietrastudio.com/public/file_uploads/37f1d8547b6c43ad937d68af952d084f.jpg',
        'https://static.pietrastudio.com/public/file_uploads/dfd5dda5d560fb72f09ade42fb5f6d0b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/f26a0179c38441d098d7266ec8a5d51e.jpg',
        'https://static.pietrastudio.com/public/file_uploads/1ca1a27663a9ba5cee9a19f04b20d045.jpg',
        'https://static.pietrastudio.com/public/file_uploads/1a79233e49d8f27a53ab324d9ae5fb24.jpg',
        'https://static.pietrastudio.com/public/file_uploads/1059a5692899ea180f96d28de034ba35.jpg',
      ],
      [AIToolsClothingModelGeneratorModelClassProps.MODEL]: [
        'https://static.pietrastudio.com/public/file_uploads/8334b34047d6e001f1b19aa176378ec2.png',
        'https://static.pietrastudio.com/public/file_uploads/32290dab4ccd247e69523aefadc47aca.jpg',
        'https://static.pietrastudio.com/public/file_uploads/20f258b98a3a0a107f7980764d271c98.jpg',
        'https://static.pietrastudio.com/public/file_uploads/dd8d8839f5193658e783ac8d10e32e48.jpg',
        'https://static.pietrastudio.com/public/file_uploads/bf18f1247bd79fe4693a292cbb797968.jpg',
        'https://static.pietrastudio.com/public/file_uploads/5e31f7050ebae2e40969cecc3d4dabb1.jpg',
        'https://static.pietrastudio.com/public/file_uploads/7e8ca24c8a78c36cdd6e16fa00f6bd74.jpg',
      ],
    },
    [AIToolsClothingModelGeneratorModelTypeProps.HD]: {
      [AIToolsClothingModelGeneratorModelClassProps.CLOTH]: [
        'https://static.pietrastudio.com/public/file_uploads/37f1d8547b6c43ad937d68af952d084f.jpg',
        'https://static.pietrastudio.com/public/file_uploads/dfd5dda5d560fb72f09ade42fb5f6d0b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/f26a0179c38441d098d7266ec8a5d51e.jpg',
        'https://static.pietrastudio.com/public/file_uploads/1ca1a27663a9ba5cee9a19f04b20d045.jpg',
        'https://static.pietrastudio.com/public/file_uploads/1a79233e49d8f27a53ab324d9ae5fb24.jpg',
        'https://static.pietrastudio.com/public/file_uploads/1059a5692899ea180f96d28de034ba35.jpg',
      ],
      [AIToolsClothingModelGeneratorModelClassProps.MODEL]: [
        'https://static.pietrastudio.com/public/file_uploads/8334b34047d6e001f1b19aa176378ec2.png',
        'https://static.pietrastudio.com/public/file_uploads/32290dab4ccd247e69523aefadc47aca.jpg',
        'https://static.pietrastudio.com/public/file_uploads/20f258b98a3a0a107f7980764d271c98.jpg',
        'https://static.pietrastudio.com/public/file_uploads/dd8d8839f5193658e783ac8d10e32e48.jpg',
        'https://static.pietrastudio.com/public/file_uploads/bf18f1247bd79fe4693a292cbb797968.jpg',
        'https://static.pietrastudio.com/public/file_uploads/5e31f7050ebae2e40969cecc3d4dabb1.jpg',
        'https://static.pietrastudio.com/public/file_uploads/7e8ca24c8a78c36cdd6e16fa00f6bd74.jpg',
      ],
    },
  },
  [AIToolsClothingModelGeneratorCategoryProps.DRESS]: {
    [AIToolsClothingModelGeneratorModelTypeProps.DC]: {
      [AIToolsClothingModelGeneratorModelClassProps.CLOTH]: [
        'https://static.pietrastudio.com/public/file_uploads/967ecfba20428b0a105b4c792e918a1b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/f3825472b8eb602ebbd81970ef15bdb7.jpg',
        'https://static.pietrastudio.com/public/file_uploads/c3d08c64bb78108e7f88e224d3d780ce.jpg',
        'https://static.pietrastudio.com/public/file_uploads/1c6b3787859b637670760dc45f175ce6.jpg',
        'https://static.pietrastudio.com/public/file_uploads/3f107b0d1224ea17bf3f90bd98da6add.jpg',
        'https://static.pietrastudio.com/public/file_uploads/8b1d7c6cc01749cf736fba88379b4523.jpg',
        'https://static.pietrastudio.com/public/file_uploads/b97887fc15b15835240afff5e2def02b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/e8974cadba27333d6c8cbf5d9a2a43f8.jpg',
      ],
      [AIToolsClothingModelGeneratorModelClassProps.MODEL]: [
        'https://static.pietrastudio.com/public/file_uploads/ebadcfed23f860cf71fd591a6a41d91f.jpg',
        'https://static.pietrastudio.com/public/file_uploads/ebfe2c93c58180ac740b8a0cadcefe30.png',
        'https://static.pietrastudio.com/public/file_uploads/cd70fd0f941c2dbfe23a35412e075ceb.jpg',
        'https://static.pietrastudio.com/public/file_uploads/65c8932f43617a54ad890d866069b803.jpg',
        'https://static.pietrastudio.com/public/file_uploads/633d8f5e4b29dbc10d3658412c70fd4b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/2d7ac0987710a637246c2c6d93304c80.jpg',
        'https://static.pietrastudio.com/public/file_uploads/20cf88e9154d45d98d899f9060ba3a3b.jpg',
      ],
    },
    [AIToolsClothingModelGeneratorModelTypeProps.HD]: {
      [AIToolsClothingModelGeneratorModelClassProps.CLOTH]: [
        'https://static.pietrastudio.com/public/file_uploads/967ecfba20428b0a105b4c792e918a1b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/f3825472b8eb602ebbd81970ef15bdb7.jpg',
        'https://static.pietrastudio.com/public/file_uploads/c3d08c64bb78108e7f88e224d3d780ce.jpg',
        'https://static.pietrastudio.com/public/file_uploads/1c6b3787859b637670760dc45f175ce6.jpg',
        'https://static.pietrastudio.com/public/file_uploads/3f107b0d1224ea17bf3f90bd98da6add.jpg',
        'https://static.pietrastudio.com/public/file_uploads/8b1d7c6cc01749cf736fba88379b4523.jpg',
        'https://static.pietrastudio.com/public/file_uploads/b97887fc15b15835240afff5e2def02b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/e8974cadba27333d6c8cbf5d9a2a43f8.jpg',
      ],
      [AIToolsClothingModelGeneratorModelClassProps.MODEL]: [
        'https://static.pietrastudio.com/public/file_uploads/ebadcfed23f860cf71fd591a6a41d91f.jpg',
        'https://static.pietrastudio.com/public/file_uploads/ebfe2c93c58180ac740b8a0cadcefe30.png',
        'https://static.pietrastudio.com/public/file_uploads/cd70fd0f941c2dbfe23a35412e075ceb.jpg',
        'https://static.pietrastudio.com/public/file_uploads/65c8932f43617a54ad890d866069b803.jpg',
        'https://static.pietrastudio.com/public/file_uploads/633d8f5e4b29dbc10d3658412c70fd4b.jpg',
        'https://static.pietrastudio.com/public/file_uploads/2d7ac0987710a637246c2c6d93304c80.jpg',
        'https://static.pietrastudio.com/public/file_uploads/20cf88e9154d45d98d899f9060ba3a3b.jpg',
      ],
    },
  },
};

export const AI_TOOLS_GENERATE_REPLACEMENTS = [
  [
    'Donald Trump',
    'The white-haired Mar-a-Lago owner, wearing a dark blue suit and a white T-shirt, raising his right fist with his mouth wide open,',
  ],
  [
    'Former President Trump',
    'The white-haired Mar-a-Lago owner, wearing a dark blue suit and a white T-shirt, raising his right fist with his mouth wide open,',
  ],
  [
    'Trump',
    'The white-haired Mar-a-Lago owner, wearing a dark blue suit and a white T-shirt, raising his right fist with his mouth wide open,',
  ],
  [
    'The 45th President',
    'The white-haired Mar-a-Lago owner, wearing a dark blue suit and a white T-shirt, raising his right fist with his mouth wide open,',
  ],
  [
    'Donald',
    'The white-haired Mar-a-Lago owner, wearing a dark blue suit and a white T-shirt, raising his right fist with his mouth wide open,',
  ],
  [
    'Donald J. Trump',
    'The white-haired Mar-a-Lago owner, wearing a dark blue suit and a white T-shirt, raising his right fist with his mouth wide open,',
  ],
  [
    'President Trump',
    'The white-haired Mar-a-Lago owner, wearing a dark blue suit and a white T-shirt, raising his right fist with his mouth wide open,',
  ],
  [
    'The former U.S. President',
    'The white-haired Mar-a-Lago owner, wearing a dark blue suit and a white T-shirt, raising his right fist with his mouth wide open,',
  ],
  ['shot', 'injured by a gunshot'],
];
